var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pass-validator',{attrs:{"payload":_vm.registered_info_content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }